export default __webpack_public_path__ + "static/media/screen5.6fe4681a.png";